<ng-container *transloco="let t">
  <div class="ag-theme-quartz h-full">
    <ag-grid-angular class="h-full" [rowData]="gridData" [gridOptions]="gridOptions"></ag-grid-angular>
  </div>
</ng-container>
